import { useEffect } from 'react'
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

let isInitialised = false

const initGrafanaFaro = () => {
  if (isInitialised) {
    return undefined
  }

  isInitialised = true

  const apiKey = process.env.NEXT_PUBLIC_GRAFANA_API_KEY
  const name = process.env.NEXT_PUBLIC_GRAFANA_NAME

  if (!apiKey || !name) {
    return undefined
  }

  try {
    return initializeFaro({
      url: `https://faro-collector-prod-au-southeast-1.grafana.net/collect/${apiKey}`,
      app: {
        name,
        version: '1.0.0',
        environment: 'production',
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
      ],
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    return undefined
  }
}

const GrafanaFaroInitialize = (): React.JSX.Element => {
  useEffect(() => {
    initGrafanaFaro()
  }, [])
  return null
}
export default GrafanaFaroInitialize
